import { IEmptyAlertBehavior, IEmptyAlertBehaviorSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanEmptyAlertValidatable } from "../../../beans/objects";

export class EmptyAlertBehaviorTranslator {
  from(bean: IObjectBeanEmptyAlertValidatable): IEmptyAlertBehavior {
    return {
      isEnable: (bean["@empty-check"] === "1"),
    };
  }

  to(o: IEmptyAlertBehaviorSpecifiable) {
    return {
      emptyCheck: o.emptyAlertBehavior.isEnable
        ? "1"
        : undefined,
    };
  }
}
